export default [
  {
    path: '/live-dashboard/sales',
    name: 'SalesDashboard',
    component: () => import('@/views/Dashboard/Live/SalesDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: 'Sıfır Satış',
      breadcrumb: null,
      resource: 'RP_SALES_LIVE_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/live-dashboard/i2-sales',
    name: 'I2SalesDashboard',
    component: () => import('@/views/Dashboard/Live/I2SalesDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: '2. El Satış',
      breadcrumb: null,
      resource: 'RP_SECONDHAND_LIVE_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/live-dashboard/insurances',
    name: 'InsurancesDashboard',
    component: () => import('@/views/Dashboard/Live/InsurancesDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: 'Sigorta',
      breadcrumb: null,
      resource: 'RP_INSURANCE_LIVE_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/live-dashboard/crm',
    name: 'CrmDashboard',
    component: () => import('@/views/Dashboard/Live/CrmDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: null,
      resource: 'RP_CRM_LIVE_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/live-dashboard/realty-sales',
    name: 'RealtySalesDashboard',
    component: () => import('@/views/Dashboard/Live/RealtySalesDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: 'Gayrimenkul',
      breadcrumb: null,
      resource: 'RP_REALTY_SALES_LIVE_DASHBOARD',
      action: 'read',
    },
  },
  {
    path: '/live-dashboard/service',
    name: 'ServiceDashboard',
    component: () => import('@/views/Dashboard/Live/ServiceDashboard.vue'),
    meta: {
      hidden: true,
      pageTitle: 'Servis',
      breadcrumb: null,
      resource: 'RP_SERVICE_LIVE_DASHBOARD',
      action: 'read',
    },
  },
]
